export const waiverEditHeaderSteps: string[] = [
  "Job Information",
  "Employees",
  "Cert Holder",
  "Location",
  "Review",
  "Submit",
];
